export const AREAS = [
  ["pipeline", "Pipeline"], ["applications", "Applications & Approvals"], ["contracts", "Contracts"], ["horse_ads", "Horse Ads"],
  ["review", "Review Queue"], ["contacts", "Contacts"], ["settings", "Settings"],
];
const LANDING = { pipeline: "/pipeline", applications: "/applications", contracts: "/applications", horse_ads: "/horses", review: "/review", contacts: "/contacts", settings: "/settings" };
const PATH_AREAS = [["/pipeline", ["pipeline"]], ["/applications", ["applications", "contracts"]], ["/horses", ["horse_ads"]], ["/horse/", ["horse_ads"]],
  ["/review", ["review"]], ["/contacts", ["contacts"]], ["/seller-preview", ["horse_ads"]], ["/style-library", ["horse_ads"]], ["/settings", ["settings"]], ["/price-list", ["__admin_only"]], ["/bids", ["__admin_only"]], ["/groups", ["__admin_only"]]];

export const isAdminRole = (u) => ["admin", "super_admin"].includes(u?.role);
export const canSee = (u, ...areas) => isAdminRole(u) || (u?.role === "staff" && areas.some((a) => (u.permissions || []).includes(a)));
export const pathAreas = (to) => PATH_AREAS.find(([p]) => to.startsWith(p))?.[1];
export const canOpen = (u, to) => { const a = pathAreas(to); return !a || canSee(u, ...a); };
export const landing = (u) => {
  if (isAdminRole(u)) return "/pipeline";
  if (u?.role === "staff") { const f = AREAS.find(([a]) => (u.permissions || []).includes(a)); return f ? LANDING[f[0]] : "/dashboard"; }
  return "/dashboard";
};
export const ROLE_LABEL = { super_admin: "Super Admin", admin: "Admin", staff: "Staff", seller: "Seller" };
export const STATUS_LABEL = { active: "Active", suspended: "Suspended", deactivated: "Deactivated", deleted: "Deleted" };
export const STATUS_TONE = {
  active: "bg-emerald-50 text-emerald-700 border-emerald-200", suspended: "bg-amber-50 text-amber-800 border-amber-200",
  deactivated: "bg-stone-100 text-stone-600 border-stone-300", deleted: "bg-red-50 text-red-700 border-red-200",
};
